export const environment = {
  production: true,
  pathapi: 'https://uat-backend.foreignadmits.app/api',
  path: 'https://uat-backend.foreignadmits.app/'
};

// Sub-domain
//  - uat.Loan.ForeignAdmits.app